/**
 * FilterList
 * - Provides options for filtering alerts on the alerts list page
 * - Includes dropdown to filter by alert types
 */
import React from 'react';
import { Theme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useIsSmallScreen } from '../../../system/SystemMediaQueriesProvider';

interface FilterListProps {
  theme: Theme;
  selectedAlertType: string;
  handleAlertTypeSelect: (alertType: string) => void;
}

const ALERT_TYPES = [
  { key: 'all', label: 'All Alerts' },
  { key: 'SOURCE_OFFLINE', label: 'Sources Offline' },
  { key: 'DEVICE_OFFLINE', label: 'Devices Offline' },
  { key: 'EQUIPMENT_ALARM', label: 'Equipment Alarm' },
  { key: 'LEAK_DETECTED', label: 'Leak Detected' },
  { key: 'THRESHOLD_ALERTS', label: 'Threshold Alerts' },
];

export function FilterList(props: FilterListProps) {
  const { selectedAlertType, handleAlertTypeSelect } = props;

  const _isSmall = useIsSmallScreen();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: '100%',
        marginTop: _isSmall ? '4px' : 'unset',
      }}
    >
      <Stack
        direction={_isSmall ? 'column' : 'row'}
        sx={{
          justifyContent: 'center',
          width: _isSmall ? '100%' : 'unset',
          alignItems: _isSmall ? 'unset' : 'center',
        }}
      >
        {!_isSmall ? (
          <div
            style={{
              display: 'flex',
              flex: '0 1 auto',
              flexDirection: 'column',
              justifyContent: 'center',
              margin: '0px 6px',
            }}
          >
            Filter by Alert Type:
          </div>
        ) : null}
        <FormControl sx={{ m: 1, minWidth: 300 }} size="small" color="info">
          {_isSmall ? (
            <InputLabel
              sx={{
                backgroundColor: 'white',
                padding: '1px 4px',
                borderRadius: '4px',
              }}
              id="alert-type-label"
            >
              Filter by Alert Type
            </InputLabel>
          ) : null}
          <Select
            value={selectedAlertType}
            onChange={(e) => handleAlertTypeSelect(e.target.value)}
            label={_isSmall ? 'Filter by Alert Type' : ''}
            sx={{
              backgroundColor: 'white',
            }}
          >
            {ALERT_TYPES.map((alertType) => (
              <MenuItem key={alertType.key} value={alertType.key}>
                {alertType.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </Box>
  );
}
